import { render, staticRenderFns } from "./tappay.vue?vue&type=template&id=7c8f5d04&"
import script from "./tappay.vue?vue&type=script&lang=js&"
export * from "./tappay.vue?vue&type=script&lang=js&"
import style0 from "./tappay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports